import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Component, Fragment } from 'react';

import markdownToHTML from 'app/utils/markdownToHTML';

import AssistantSummaryItem from './AssistantSummaryItem';

type AssistantSummaryProps = {
  messages: any;
};

type StateT = {
  showMore: boolean;
};

export default class AssistantSummary extends Component<
  AssistantSummaryProps,
  StateT
> {
  constructor(props: AssistantSummaryProps) {
    super(props);

    this.state = {
      showMore: false,
    };
  }

  toggleExpand = () => {
    const { showMore } = this.state;
    this.setState({
      showMore: !showMore,
    });
  };

  renderMessage(message) {
    const { type } = message;

    if (type === 'conversation:conversational_assistant_menu') {
      return (
        <AssistantSummaryItem
          key={message.id}
          category="Menu"
          message={markdownToHTML(message.chat_menu_text)}
          action={`${message.author.name} clicked`}
          value={message.chat_menu_choice_label}
        />
      );
    }

    if (type === 'conversation:conversational_assistant_input') {
      return (
        <AssistantSummaryItem
          key={message.id}
          category="Input"
          message={markdownToHTML(message.chat_input_question)}
          action={`${message.author.name} put in`}
          value={message.chat_input_answer}
        />
      );
    }

    if (type === 'conversation:conversational_assistant_message') {
      return (
        <AssistantSummaryItem
          key={message.id}
          category="Message"
          message={markdownToHTML(message.text)}
        />
      );
    }
    return null;
  }

  render() {
    const { messages } = this.props;
    const { showMore } = this.state;

    if (messages.length === 0) return null;

    const rootClass = classnames('assistant-summary', {
      'assistant-summary--showMore': showMore,
    });
    const lastThree = messages.slice(-3);
    const hiddenMessages =
      messages.length > 3 ? messages.slice(0, messages.length - 3) : [];

    return (
      <div className={rootClass}>
        <h2 className="assistant-summary__headline">
          Conversational Assistant
        </h2>
        <ul className="assistant-summary__list">
          {hiddenMessages.length > 0 && (
            <ul>
              <li
                className={classnames(
                  'assistant-summary-item',
                  'assistant-summary-item__expandable',
                  {
                    'assistant-summary-item__expanded': showMore,
                  },
                )}
              >
                <div className="assistant-summary-item__bullet assistant-summary-item__bullet--showMore">
                  <button
                    onClick={this.toggleExpand}
                    className="assistant-summary-item__toggle"
                  >
                    <Icon name="angle-right" size={16} />
                  </button>
                </div>
                <span className="assistant-summary-item__text">
                  {`${
                    showMore
                      ? 'Hide previous messages'
                      : 'Show previous messages'
                  }`}
                </span>
              </li>
              {showMore && (
                <Fragment>
                  {hiddenMessages.map((message) => this.renderMessage(message))}
                </Fragment>
              )}
            </ul>
          )}

          {lastThree.map((message) => this.renderMessage(message))}
        </ul>
      </div>
    );
  }
}
